import { Controller } from '@hotwired/stimulus'

import BigPicture from 'bigpicture'

export default class extends Controller {
  static values = {
    service: String
  }

  static targets = [
    "body",
    "content"
  ]

  connect() {
    if (this.serviceValue === "default") this.transformHashtags()

    this.assignEventToImage()

    if (['default', 'poll'].includes(this.serviceValue)) {
      setTimeout(() => this.removeFreshClass(), 500)
    }
  }

  assignEventToImage() {
    if (!this.element.querySelector('.text > img')) { return }

    this.contentTarget.querySelectorAll('.text > img').forEach((el) => {
      el.onclick = () => {
        BigPicture({
          el: el,
          imgSrc: el.src
        })
      }
    })
  }

  removeFreshClass() {
    this.bodyTarget.classList.remove("fresh")
  }

  transformHashtags() {
    // Regular expression to match hashtags
    const hashtagRegex = /#[\w\u0080-\uFFFF]+/g

    const currentContent = this.contentTarget.innerHTML

    // Replace hashtags with links
    this.contentTarget.innerHTML = currentContent.replace(hashtagRegex, (hashtag) => {
      const encodedHashtag = encodeURIComponent(hashtag)
      return `<a data-turbo-frame="_top" href="/search?q=${encodedHashtag}">${hashtag}</a>`
    })
  }
}
